import { slashFormat } from 'utilities';
import { CashDistributionLedgerAcquisition } from '../../cash-distribution/CashDistributionLedger.props';
import { PurchaseDateOption } from '../components/purchase-date-select/PurchaseDateSelect.props';

const generatePurchaseDateOptions = (acquisitions: CashDistributionLedgerAcquisition[]): PurchaseDateOption[] =>
  acquisitions
    .filter(acq => !!acq.purchase_date)
    .map(acquisition => ({
      label: slashFormat(acquisition.purchase_date),
      value: acquisition.acquisition_ref,
    }));

export default generatePurchaseDateOptions;
